var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPlusGreen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 1.53973C3.95033 1.53973 0.666992 4.66672 0.666992 8.52386C0.666992 12.381 3.95033 15.508 8.00033 15.508C12.0503 15.508 15.3337 12.381 15.3337 8.52386C15.3337 4.66672 12.0503 1.53973 8.00033 1.53973ZM8.66699 11.0635C8.66699 11.2319 8.59675 11.3934 8.47173 11.5125C8.34671 11.6316 8.17714 11.6985 8.00033 11.6985C7.82351 11.6985 7.65395 11.6316 7.52892 11.5125C7.4039 11.3934 7.33366 11.2319 7.33366 11.0635V9.15878H5.33366C5.15685 9.15878 4.98728 9.09189 4.86225 8.97282C4.73723 8.85375 4.66699 8.69225 4.66699 8.52386C4.66699 8.35547 4.73723 8.19398 4.86225 8.0749C4.98728 7.95583 5.15685 7.88894 5.33366 7.88894H7.33366V5.98418C7.33366 5.81579 7.4039 5.65429 7.52892 5.53522C7.65395 5.41615 7.82351 5.34926 8.00033 5.34926C8.17714 5.34926 8.34671 5.41615 8.47173 5.53522C8.59675 5.65429 8.66699 5.81579 8.66699 5.98418V7.88894H10.667C10.8438 7.88894 11.0134 7.95583 11.1384 8.0749C11.2634 8.19398 11.3337 8.35547 11.3337 8.52386C11.3337 8.69225 11.2634 8.85375 11.1384 8.97282C11.0134 9.09189 10.8438 9.15878 10.667 9.15878H8.66699V11.0635Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPlusGreen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-plus-green.bbd8f9b8.svg";
export { ForwardRef as ReactComponent };